import {
  FolderOpen, Users, Truck, Tags, Award, Ruler, Building2,
  Package, FileText, ArrowRightLeft, ShoppingCart, Inbox,
  Wallet, TrendingDown, FileCheck2, Library, ClipboardList, PackagePlus,
  Clock, UserCheck, TrendingUp,
  Globe, Megaphone, Images,
  ShieldCheck, Palette, Receipt, Coins, Laptop, Smartphone, Landmark,
  Boxes, PackageSearch, AlertTriangle, MapPin, ScrollText, Handshake, Replace, ClipboardCheck,
  PhoneCall, PlayCircle, BookOpen, Route, PackageX, ScanSearch,
} from 'lucide-react';
import type { ComponentType } from 'react';
import { WhatsAppIcon } from '../components/WhatsAppIcon';

export type TelaNavegavel = {
  to: string;
  label: string;
  icon: ComponentType<{ size?: number; strokeWidth?: number }>;
  grupo: string;
};

/** Lista mestra de todas as telas com rota do sistema — alimenta o menu MOBILE/HAMBURGER
 * (e o tablet em Modo Tablet, DA-387). Itens de menu que abrem modal (Cores inline, Baileys,
 * etc.) NÃO entram — não têm rota. `podeConfigurar` = admin ou gerente — adiciona Configurações.
 *
 * ⚠️ ESTA LISTA É PARALELA aos menus do desktop em `Layout.tsx` (arrays `arquivos`/`lancamentos`/
 * `estoqueSub`/etc). As duas precisam andar JUNTAS: tela nova com rota entra AQUI também, senão
 * ela aparece no menu horizontal do desktop e SOME no hamburger — foi o que aconteceu com as 4
 * telas de Estoque (criadas 17/07, só apareceram aqui em 28/07 quando o estoquista do tablet
 * reclamou que não achava Estoque). Ao adicionar/remover rota no `Layout.tsx`, espelhar aqui.
 */
export function telasNavegaveis(podeConfigurar: boolean): TelaNavegavel[] {
  const base: TelaNavegavel[] = [
    // Arquivos
    { to: '/produtos', label: 'Produtos', icon: Package, grupo: 'Arquivos' },
    { to: '/cadastros/clientes', label: 'Clientes', icon: Users, grupo: 'Arquivos' },
    { to: '/cadastros/fornecedores', label: 'Fornecedores', icon: Truck, grupo: 'Arquivos' },
    { to: '/cadastros/grupos', label: 'Grupos', icon: FolderOpen, grupo: 'Arquivos' },
    { to: '/cadastros/categorias', label: 'Categorias', icon: Tags, grupo: 'Arquivos' },
    { to: '/cadastros/marcas', label: 'Marcas', icon: Award, grupo: 'Arquivos' },
    { to: '/cadastros/categorias-despesa', label: 'Cat. de Despesa', icon: Coins, grupo: 'Arquivos' },
    { to: '/cadastros/unidades-medida', label: 'Unidades', icon: Ruler, grupo: 'Arquivos' },
    { to: '/cadastros/cidades', label: 'Cidades', icon: Building2, grupo: 'Arquivos' },
    { to: '/cadastros/localizacoes', label: 'Localizacoes', icon: MapPin, grupo: 'Arquivos' },
    { to: '/configuracoes/situacoes-tributarias', label: 'Sit. Tributaria', icon: Receipt, grupo: 'Arquivos' },
    { to: '/cadastros/usuarios', label: 'Usuarios', icon: Users, grupo: 'Arquivos' },
    // Lancamentos
    { to: '/orcamentos', label: 'Orcamentos', icon: FileText, grupo: 'Lancamentos' },
    { to: '/caixa', label: 'Caixa', icon: ShoppingCart, grupo: 'Lancamentos' },
    { to: '/trocas', label: 'Trocas e Devolucoes', icon: ArrowRightLeft, grupo: 'Lancamentos' },
    { to: '/cotacoes', label: 'Cotacoes', icon: ShoppingCart, grupo: 'Lancamentos' },
    { to: '/catalogo-fornecedor', label: 'Catalogo de Fornecedor', icon: Library, grupo: 'Lancamentos' },
    { to: '/novos-produtos', label: 'Novos Produtos', icon: PackagePlus, grupo: 'Lancamentos' },
    { to: '/monitor-precos', label: 'Monitor de Custos', icon: TrendingUp, grupo: 'Lancamentos' },
    { to: '/rastreio', label: 'Rastreio', icon: Route, grupo: 'Lancamentos' },
    { to: '/cotacoes/mais-vendidos', label: 'Mais Vendidos', icon: TrendingUp, grupo: 'Lancamentos' },
    { to: '/lista-compras', label: 'Lista de Compras', icon: ClipboardList, grupo: 'Lancamentos' },
    { to: '/notas-entrada', label: 'Notas de Entrada', icon: Inbox, grupo: 'Lancamentos' },
    { to: '/notas-fiscais', label: 'Notas Fiscais', icon: FileCheck2, grupo: 'Lancamentos' },
    // Ultimo de Lancamentos, como no desktop (pedido dele, DA-868). Todo perfil registra.
    { to: '/vendas-perdidas', label: 'Venda Perdida', icon: PackageX, grupo: 'Lancamentos' },
    // Estoque (submenu de Lancamentos no desktop; grupo proprio no mobile pra o estoquista achar de cara)
    { to: '/estoque/conferencia', label: 'Conferencia dos Vendidos', icon: ClipboardCheck, grupo: 'Estoque' },
    { to: '/estoque/localizacoes', label: 'Localizacoes por Produtos', icon: MapPin, grupo: 'Estoque' },
    { to: '/estoque/prateleiras', label: 'Estoque por Prateleira', icon: Boxes, grupo: 'Estoque' },
    { to: '/estoque/reposicoes', label: 'Reposicoes', icon: PackageSearch, grupo: 'Estoque' },
    { to: '/estoque/transferir', label: 'Transferir Estoque', icon: Replace, grupo: 'Estoque' },
    { to: '/estoque/inconsistencias', label: 'Inconsistencias', icon: AlertTriangle, grupo: 'Estoque' },
    // Financeiro
    { to: '/financeiro', label: 'Financeiro', icon: Landmark, grupo: 'Financeiro' },
    { to: '/contas-receber', label: 'Contas a Receber', icon: Wallet, grupo: 'Financeiro' },
    { to: '/contas-pagar', label: 'Contas a Pagar', icon: TrendingDown, grupo: 'Financeiro' },
    { to: '/consignacao', label: 'Consignacao', icon: Receipt, grupo: 'Financeiro' },
    // Equipe
    { to: '/ponto/registrar', label: 'Bater Ponto', icon: Clock, grupo: 'Equipe' },
    { to: '/orcamentos/fila', label: 'Gestao de Vendas', icon: PhoneCall, grupo: 'Equipe' },
    { to: '/equipe', label: 'Visualizar Equipe', icon: UserCheck, grupo: 'Equipe' },
    { to: '/comissoes', label: 'Comissoes', icon: TrendingUp, grupo: 'Equipe' },
    { to: '/equipe/estatisticas-agentes', label: 'Estatisticas dos agentes', icon: TrendingUp, grupo: 'Equipe' },
    { to: '/equipe/diario', label: 'Diario', icon: ScrollText, grupo: 'Equipe' },
    // Marketing
    { to: '/catalogo-gestao', label: 'Catalogo Digital', icon: Globe, grupo: 'Marketing' },
    { to: '/promocoes', label: 'Promocoes', icon: Megaphone, grupo: 'Marketing' },
    { to: '/gestao-fotos', label: 'Gestao de Fotos', icon: Images, grupo: 'Marketing' },
    // Manual (29/09/2026)
    { to: '/treinamento', label: 'Videos de Treinamento', icon: PlayCircle, grupo: 'Manual' },
    { to: '/manual', label: 'Manual Escrito', icon: BookOpen, grupo: 'Manual' },
    // Atendimento
    { to: '/atendimento', label: 'Atendimento', icon: WhatsAppIcon, grupo: 'Atendimento' },
  ];

  if (podeConfigurar) {
    base.push(
      // Premio do Estoquista (DA-868): a auditoria e o painel sao so admin/gerente — o estoquista
      // nao pode ver o sorteio.
      { to: '/estoque/auditoria', label: 'Auditoria do Estoque', icon: ScanSearch, grupo: 'Estoque' },
      { to: '/equipe/premio-estoque', label: 'Premio do Estoquista', icon: Award, grupo: 'Equipe' },
    );
    base.push(
      { to: '/configuracoes/rds', label: 'RDS - Regras do Sistema', icon: ShieldCheck, grupo: 'Configuracoes' },
      { to: '/configuracoes/dispositivos', label: 'Dispositivos Autorizados', icon: Laptop, grupo: 'Configuracoes' },
      { to: '/configuracoes/appcel', label: 'AppCel', icon: Smartphone, grupo: 'Configuracoes' },
      { to: '/configuracoes/cores', label: 'Cores', icon: Palette, grupo: 'Configuracoes' },
      { to: '/configuracoes/fiscal', label: 'Fiscal', icon: Receipt, grupo: 'Configuracoes' },
      { to: '/configuracoes/programas/parceiro', label: 'Parceiro FIODECOBRE', icon: Handshake, grupo: 'Configuracoes' },
    );
  }

  return base;
}
